import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import useProductDetails from 'modules/products/hooks/use-product-details';
import {AdditionalGroupConfigProps} from 'modules/products/types';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import productsKeys from 'modules/products/util/products-keys';
import StatusButton from 'shared/components/status-button';
import useReorderAdditionalGroupConfigsIndexes from 'modules/products/hooks/use-reorder-additional-group-config-indexes';

const AdditionalGroupConfigs: React.FC = () => {
  const {id} = useParams();
  const {data, isLoading} = useProductDetails(id!);
  const navigate = useNavigate();
  const reorderAdditionalGroupConfigsIndexesMutation =
    useReorderAdditionalGroupConfigsIndexes(id!);

  return (
    <Table<AdditionalGroupConfigProps>
      loading={isLoading}
      data={data?.additionalGroupsConfig ?? []}
      draggable
      onDrag={(fromId, toId) =>
        reorderAdditionalGroupConfigsIndexesMutation.mutate({
          fromId,
          toId,
          productId: id,
        })
      }
      options={[
        'additionalGroup.name',
        {
          value: 'isFree',
          column: (row) => (
            <StatusButton
              text={row.isFree ? 'Sim' : 'Não'}
              variant={row.isFree ? 'success' : 'error'}
            />
          ),
        },
        'min',
        'max',
        {
          value: 'id',
          label: 'Ações',
          column: (row) => (
            <QueryDeleteButton
              url={`/products/${id!}/additional-groups-config/${row.id}`}
              queryKey={productsKeys.details(id!)}
            />
          ),
        },
      ]}
      translatedPropsKey="AdditionalGroupConfigProps"
      onRowClick={(row) => navigate(row.id)}
    />
  );
};

export default AdditionalGroupConfigs;
